"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.breakpointSizes = exports.text = exports.button = exports.card = exports.layout = exports.shadows = exports.colors = void 0;
var colors = {
  body: '#222222',
  diffuse: '#888888',
  bg: '#f5f5f5',
  secondaryBg: '#ffffff',
  border: '#eeeeee',
  primary: '#85D986',
  primaryContrast: '#ffffff',
  secondary: '#EC8B46',
  secondaryContrast: '#ffffff',
  black: '#000000',
  grey1: '#161618',
  grey2: '#3D3D43',
  grey3: '#57575C',
  grey4: '#75757A',
  grey5: '#C0C0C6',
  grey6: '#E8E8EE',
  grey7: '#F4F4FA',
  grey8: '#F0F0F0',
  white: '#FFFFFF',
  destructive: '#C60C46',
  destructiveLight: '#db0f4f'
};
exports.colors = colors;
var shadows = {
  small: '0px 1px 3px 0px rgb(0, 0, 0, 0.1)',
  big: '0 5px 10px rgb(0, 0, 0, 0.1)'
};
exports.shadows = shadows;
var layout = {
  grid: 8,
  radius: 2,
  maxContentWidth: 1200,
  maxModalWidth: 600
};
exports.layout = layout;
var card = {
  bg: colors.secondaryBg
};
exports.card = card;
var button = {
  bg: colors.secondaryBg
};
exports.button = button;
var text = {
  button: {
    size: 14,
    spacing: 2
  },
  h1: {
    fontSize: 24,
    fontWeight: 'normal',
    letterSpacing: 2
  },
  h2: {
    fontSize: 18,
    fontWeight: 'normal',
    letterSpacing: 1.6
  },
  h3: {
    fontSize: 14,
    fontWeight: 'normal',
    letterSpacing: 1.2
  },
  p: {
    fontSize: 12,
    fontWeight: 'normal',
    letterSpacing: 1
  },
  small: {
    fontSize: 10,
    fontWeight: 'normal',
    letterSpacing: 1
  }
}; // no s in here as thats the default at 0-480

exports.text = text;
var breakpointSizes = {
  m: 480,
  l: 1024,
  xl: 1600
}; // there is no fromS as that'd be the default styles and we do not want
// those to be part of a min-width: 0px media queries due to CSS performance

exports.breakpointSizes = breakpointSizes;
var breakpoints = {
  // duplicate of untilM
  // > 0 && < 480
  get onlyS() {
    return this.untilM;
  },

  // < 480
  untilM: '@media (max-width: ' + (breakpointSizes.m - 1) + 'px)',
  // >= 480
  fromM: '@media (min-width: ' + breakpointSizes.m + 'px)',

  // >= 480 && < 1024
  get onlyM() {
    return this.fromM + ' and ' + this.untilL.substring(7);
  },

  // < 1024
  untilL: '@media (max-width: ' + (breakpointSizes.l - 1) + 'px)',
  // >= 1024
  fromL: '@media (min-width: ' + breakpointSizes.l + 'px)',

  // >= 1024 && < 1600
  get onlyL() {
    return this.fromL + ' and ' + this.untilXL.substring(7);
  },

  // < 1600
  untilXL: '@media (max-width: ' + (breakpointSizes.xl - 1) + 'px)',
  // >= 1600
  fromXL: '@media (min-width: ' + breakpointSizes.xl + 'px)',

  // duplicate of fromXL
  // >= 1600
  get onlyXL() {
    return this.fromXL;
  }

};
var fonts = {};
var _default = {
  breakpoints: breakpoints,
  button: button,
  card: card,
  colors: colors,
  fonts: fonts,
  grid: 8,
  layout: layout,
  radius: 2,
  shadows: shadows,
  styles: {},
  text: text
};
exports["default"] = _default;